import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const setErrorMessage = createAsyncThunk(
  'Index/setErrorMessage',
  async (errorMessage, { dispatch }) => {
    // Clear errorMessage automatically after 5 seconds
    setTimeout(() => {
      dispatch(setErrorMessage(null));
    }, 10000);

    return errorMessage;
  },
);

export const genericError = createSlice({
  name: 'genericError',
  initialState: {
    errors: [],
  },
  reducers: {
  },
  extraReducers: {
    [setErrorMessage.fulfilled]: (state, action) => {
      state.message = action.payload;
    },
  },
});

export const selectErrorMessage = (state) => state.genericError.message;

export default genericError.reducer;
